<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M10.2 16.4V3.8q0-.7.5-1.2t1.1-.4 1.1.4q.6.5.5 1.2v12.6l5.2-5.2q.5-.5 1.1-.5t1.2.5.4 1.1-.5 1.2L13 21.4l-1 .4a2 2 0 0 1-1.2-.4l-8-8q-.3-.4-.4-1 0-.7.5-1.2t1.1-.5 1.1.5z"
    />
  </svg>
</template>
